import { render, staticRenderFns } from "./CobrosFormComponent.vue?vue&type=template&id=3a5facf9&"
import script from "./CobrosFormComponent.vue?vue&type=script&lang=js&"
export * from "./CobrosFormComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports